import React from "react";
import { HelpCircle } from "lucide-react";
import { Card } from "@/components/Card/Card";
import { Skeleton } from "@/components/ui/skeleton";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface BillingSummaryCardProps {
  label: string;
  value?: string;
  detail?: string;
  tooltip?: string;
  loading?: boolean;
}

const BillingSummaryCard: React.FC<BillingSummaryCardProps> = ({
  label,
  value,
  detail,
  tooltip,
  loading = false,
}) => {
  return (
    <Card className="w-full bg-white dark:bg-slate-800">
      <div className="p-6">
        <div className="mb-2 flex items-center gap-2">
          <span className="text-sm text-gray-600 dark:text-gray-400">
            {label}
          </span>
          {tooltip && (
            <TooltipProvider>
              <Tooltip>
                <TooltipTrigger>
                  <HelpCircle className="h-4 w-4 cursor-help text-gray-400" />
                </TooltipTrigger>
                <TooltipContent className="max-w-xs">
                  <p>{tooltip}</p>
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
          )}
        </div>
        {loading ? (
          <>
            <Skeleton className="h-9 w-32 bg-gray-200 dark:bg-slate-700" />
            <Skeleton className="mt-1 h-5 w-40 bg-gray-200 dark:bg-slate-700" />
          </>
        ) : (
          <>
            <span className="text-3xl font-bold text-gray-900 dark:text-white">
              {value}
            </span>
            {detail && (
              <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
                {detail}
              </p>
            )}
          </>
        )}
      </div>
    </Card>
  );
};

export default BillingSummaryCard;
